export interface AnalyticsDataPoint {
  timestamp: string;
  significant_wave_height: number;
  maximum_wave_height: number;
  peak_wave_period: number;
  mean_wave_period: number;
  peak_wave_direction: number;
  temperature: number;
  battery_voltage: number;
  signal_strength: number;
  latitude: number;
  longitude: number;
  average_wave_height: number;
  rtc_battery_voltage: number;
  microchip_regulated_voltage: number;
  software_version: string;
  rdo_concentration: number;
  rdo_saturation: number;
  rdo_temperature: number;
  internal_sea_temperature: number;
  external_sea_temperature: number;
  board_temperature: number;
  battery_temperature: number;
  solar_panel_voltage: number;
  solar_panel_current: number;
  battery_capacity: number;
  battery_current: number;
  battery_fill: number;
  battery_rel_fill: number;
  spectrum_significant_wave_height: number;
  spectrum_maximum_wave_height: number;
  spectrum_peak_wave_period: number;
  spectrum_mean_wave_period: number;
  spectrum_peak_wave_direction: number;
  spectrum_average_wave_height: number;
}

export interface AnalyticsResponse {
  deviceId: number;
  startDate: string;
  endDate: string;
  dataPoints: AnalyticsDataPoint[];
  count: number;
}

class AnalyticsService {
  async getDeviceAnalytics(deviceId: string, startDate: Date, endDate: Date): Promise<AnalyticsResponse> {
    const response = await fetch(
      `/api/devices/${deviceId}/analytics?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch analytics data: ${response.statusText}`);
    }

    return response.json();
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;
